"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MaxLoopOverlay = void 0;

var _react = _interopRequireDefault(require("react"));

var _ = require("../../");

var _molecules = require("../../molecules");

var _atoms = require("../../atoms");

require("./MaxLoopOverlay.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Slobodan Djordjevic
 */
var MaxLoopOverlay = function MaxLoopOverlay(_ref) {
  var maxLoopCount = _ref.maxLoopCount,
      loopCount = _ref.loopCount,
      playPressed = _ref.playPressed,
      className = _ref.className,
      children = _ref.children;

  if (!loopCount || loopCount <= maxLoopCount) {
    return null;
  }

  var _onClick = function onClick(e) {
    if (e) e.stopPropagation();
  };

  var onPlayPressed = function onPlayPressed() {
    playPressed();
  };

  (0, _.trk)('MaxLoopOverlay:Opened:Overlay');
  return /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    className: "MaxLoopOverlay ".concat(className ? className : ""),
    onClick: function onClick(e) {
      return _onClick(e);
    }
  }, /*#__PURE__*/_react.default.createElement(_atoms.Column, {
    className: "content"
  }, /*#__PURE__*/_react.default.createElement(_atoms.Label, {
    center: true,
    type: _atoms.Label.Type.Heading3,
    content: "Still watching?"
  }), /*#__PURE__*/_react.default.createElement(_atoms.Row, {
    center: true,
    spacing: "8"
  }, /*#__PURE__*/_react.default.createElement(_molecules.Button, {
    trk: "MaxLoopOverlay:Continue Pressed:Button",
    onClick: function onClick() {
      return onPlayPressed();
    },
    icon: _atoms.Icon.Type.Play,
    content: "Continue",
    marginRight: "6"
  }), children)));
};

exports.MaxLoopOverlay = MaxLoopOverlay;
var _default = MaxLoopOverlay;
exports.default = _default;